module.exports = __webpack_public_path__ + "img/footer-link-logo.452d039a.png";